import React, { PureComponent } from 'react'
import { object } from 'prop-types'
import { Text, SvgGrid, SvgPathLine } from 'components'
import { translate } from 'react-i18next'
import { sortBy, max } from 'lodash'
import { toOrdinal } from 'number-to-words'

import './Race.css'

const svgViewBox = '0 0 2050 1150'
const viewBox = { x: 5, y: 50, width: 2000, height: 1000 }

@translate()
export class RaceTabCurves extends PureComponent {
    static propTypes = {
        data: object.isRequired
    }

    componentWillMount() {
        const { data } = this.props
        this.players = sortBy(data.players, 'position')
        this.lines = this.players.map(player => ({
            player,
            points: [
                { x: 0, y: 0 },
                ...player.segments.filter(s => s.isRunning).map((segment, index) => ({
                    x: index + 1,
                    y: segment.differenceVsWinner
                }))
            ]
        }))
        this.numberOfSegments = data.numberOfSegments
        const maxDistance = max(this.lines.map(line => line.points[line.points.length - 1].y))
        if (maxDistance < 25) this.distanceBetweenGridLines = 2.5
        else if (maxDistance < 50) this.distanceBetweenGridLines = 5
        else if (maxDistance < 100) this.distanceBetweenGridLines = 10
        else if (maxDistance < 150) this.distanceBetweenGridLines = 15
        else if (maxDistance < 200) this.distanceBetweenGridLines = 20
        else if (maxDistance < 250) this.distanceBetweenGridLines = 25
        else this.distanceBetweenGridLines = 50
        this.yLimit = Math.ceil(maxDistance / this.distanceBetweenGridLines) * this.distanceBetweenGridLines
        this.yNumLines = (this.yLimit / this.distanceBetweenGridLines) - 1
    }

    renderPlayer = ({ id, position, color, player }) => (
        <div key={id} className="RaceTabCurves-Player">
            <div className="PlayerColor" style={{ backgroundColor: color }} />
            {player}<small> ({toOrdinal(position)})</small>
        </div>
    )
    renderLine = ({ player, points }, index) => (
        <SvgPathLine
            key={index}
            id={player.position}
            style={{ stroke: player.color }}
            player={player.player}
            data={points}
            inputRange={{ x: [0, this.numberOfSegments], y: [this.yLimit, 0] }}
            outputViewBox={viewBox}
            clipPath="url(#viewBoxClip)"
        />
    )

    render() {
        const { t } = this.props
        return (
            <div className="RaceTabCurves h-100">
                <div className="flex row-stretch-center">
                    <div className="RaceTabCurves-Players">
                        {/* <Text>{t('game.RACE.curves.players')}</Text> */}
                        {this.players.map(this.renderPlayer)}
                    </div>
                    <div className="flex-grow">
                        <div className="flex row-stretch-center">
                            <Text>{t('game.RACE.curves.xAxis')}</Text>
                            <Text>{t('game.RACE.curves.yAxis')}</Text>
                        </div>
                        <svg className="WhiteBg" height="100%" viewBox={svgViewBox}>
                            <SvgGrid
                                viewBox={viewBox}
                                xNumLines={0}
                                yNumLines={this.yNumLines}
                                xNumLabels={this.numberOfSegments}
                                xLabels={{ num: this.numberOfSegments, toStr: x => (x * this.numberOfSegments).toFixed(0) }}
                                yLabels={{ num: this.yNumLines, toStr: y => (y === 0 ? '0' : (y * this.yLimit).toFixed(1)) }}
                                fontSize={20}
                                clipId="viewBoxClip"
                            />
                            {this.lines.map(this.renderLine)}
                        </svg>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/Race/RaceTabCurves.js